import React from "react";
import { ADD_HABITACION, REMOVE_HABITACION, SET_ADULTOS_CANTIDAD, SET_EDAD_MENORES, SET_MENORES_CANTIDAD } from "../../../context/constantes";

const CuadroHabitaciones = (props) => {
    const { habitaciones = [], dispatch, setShowDivPasajeros, isResultados } = props;

    const handleClickMasHabitacion = () => {
        dispatch({type: ADD_HABITACION});
      };
    
      const handleClickMenosHabitacion = () => {
        dispatch({type: REMOVE_HABITACION});
      };

    const dibujarOptionAdultos = (cantidad) => {
        let options = [];
        for (let i = 1; i <= cantidad; i++) {
          options.push(
            <option key={i} value={i}>
              {i}
            </option>
          );
        }
    
        return options;
      };
    
      const dibujarOptionMenores = (cantidad) => {
        let options = [];
        for (let i = 0; i <= cantidad; i++) {
          options.push(
            <option key={i} value={i}>
              {i}
            </option>
          );
        }
        return options;
      };
    
      const handleComboAdultos = (cantidad, index) => {
        dispatch({type: SET_ADULTOS_CANTIDAD, payload: {cantidad, index}});
      };
    
      const handleComboMenores = (cantidad, index) => {
        dispatch({type: SET_MENORES_CANTIDAD, payload: {cantidad, index}});
      };
    
      const handleComboEdad = (edad, indiceHab, indiceMenor) => {
        dispatch({type: SET_EDAD_MENORES, payload: {edad, indiceHab, indiceMenor}});
      };

    return (
        <div className={!isResultados ? "divPasajeros" : "divHabContenedor"}>
          {habitaciones.map((hab, i) => {
            return (
              <div
                className="row divHabRow"
                key={i}
              >
                <div style={{ width: "100%" }}
                    className="d-block">
                  <label style={{display: 'inline-block'}}>
                    Habitaci&oacute;n {i + 1}
                  </label>
                  {i > 0 && habitaciones.length - 1 === i && (
                    <span className="btnEliminarHab" onClick={handleClickMenosHabitacion}>
                      Eliminar
                    </span>
                  )}
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-8">
                  <label htmlFor="adultos">Adultos</label>
                  <select
                    style={{ display: "block", width: "100px" }}
                    name="adultos"
                    value={hab.adultos}
                    className="formControlBuscarHotel"
                    onChange={(e) =>
                      handleComboAdultos(e.target.value, i)
                    }
                  >
                    {dibujarOptionAdultos(6)}
                  </select>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-8">
                  <label htmlFor="menores">Menores</label>
                  <select
                    style={{ display: "block", width: "100px" }}
                    name="menores"
                    value={hab.menores.length}
                    className="formControlBuscarHotel"
                    onChange={(e) =>
                      handleComboMenores(e.target.value, i)
                    }
                  >
                    {dibujarOptionMenores(2)}
                  </select>
                </div>
                {hab.menores.map((value, key) => {
                  return (
                    <div
                      className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-8"
                      key={key}
                    >
                      <label>Edad Menor</label>
                      <select
                        id={key}
                        style={{ display: "block", width: "100px" }}
                        className="formControlBuscarHotel"
                        value={value}
                        onChange={(e) =>
                          handleComboEdad(e.target.value, i, key)
                        }
                      >
                        {dibujarOptionMenores(8)}
                      </select>
                    </div>
                  );
                })}
                <hr />
              </div>
            );
          })}
          {habitaciones.length < 4 && (
            <div className="btnAgregarHab" style={{color: isResultados ? '#fff' : '#000'}}>
            <span onClick={handleClickMasHabitacion}>
              Añadir Habitación
            </span>
          </div>
          )}
          {!isResultados && (
            <div style={{ textAlign: "right" }}>
              <button
                className="botonBuscarHotel"
                onClick={() => setShowDivPasajeros(false)}
              >
                Aplicar
              </button>
            </div>
          )}
        </div>
      )
}

export default CuadroHabitaciones;


// WEBPACK FOOTER //
// ./src/components/Hoteles/BuscadorHotel/cuadroHabitaciones.js